module.exports = {
  lange: {
    hversion: '版本',
    zsize: '大小',
    updateTime: '更新時間',
    Android: '安卓下載',
    Apple: '蘋果下載',
    title: '或掃描下方二維碼下載',
    QRcode: '掃描二維碼下載',
    mobile: '或用手機瀏覽器輸入這個網址:',
    facilityAndroid: '適用於安卓手機',
    facilityiPhone: '適用於蘋果手機',
    ilucode: '擼碼分發',
    disclaimer: '免責聲明',
    report: '舉報',
    install: '安裝中...請查看桌面!',
    explain: '作爲第三方內測分發平台，我們一直致力于打擊違規應用，保護用戶權益。非常感謝您的舉報，我們會在第一時間安排專人處理您的舉報問題。感謝您對我們的支持。',
    reptype: '請選擇舉報類型：',
    pirate: '盜版',
    yellow: '黃色',
    cheat: "欺詐",
    other: '其他',
    Reasons: '舉報原因：',
    replenish: '請補充一下舉報原因...',
    email: '郵箱：',
    write: '請填寫郵箱地址',
    affirm: '舉 報',
    back: '取 消',
    phone: '電話號碼：',
    mobiles: '請輸入您的手機號',
    one: '請選擇舉報類型',
    two: '請補充原因',
    three: '請填寫郵箱',
    four: '請填寫正確的郵箱',
    five: '請填寫您的手機號',
    six: '請填寫正確的手機號',
    freeDown: '免費下載',
    introduction: '簡介',
    ZeroScore: '0個評分',
    Rating: '評分及評論',
    age: '年齡',
    points: '滿分 5 分',
    newFunction: '新功能',
    message: '信息',
    nstallation: '安裝包大小',
    compatibility: '兼容性',
    language: '語言',
    grading: '年齡分級',
    price: '價格',
    compatibilityInfo: '需要iOS或更高版本。與iPhone、iPad和iPodtouch兼容。',
    limit: '限4歲以上',
    free: '免費',
    tutorial: '安装教程',
    languageInfo: '繁體中文',
    introduce: '應用介紹',
    remark: '備註',
    contact: '聯繫方式',
    password: '請輸入密碼',
    enter: '確認',
    phonecode: '驗證碼',
    tsphonecode: '請輸入正確的驗證碼',
    inphonecode: '請輸入圖片驗證碼',
    errphonecode: '圖片驗證碼錯誤',
    errcode: '密碼錯誤',
    download: '下載安裝',
    downipa: '“未受信任的企業開發者”的解決辦法',
    downsuper: '安裝教程',
    instaling: '正在安裝，請稍後......',
    iosDescribe: '信任開發者',
    superDescribe: '安裝配置描述',
    iOSAndroid: '適用於安卓和蘋果手機',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/tw.js